import { render } from "./About.vue?vue&type=template&id=2e53a1e2&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=2e53a1e2&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e53a1e2"]])

export default __exports__